import _objectDestructuringEmpty from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _asyncToGenerator from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/book.png';
import _imports_1 from '@/assets/images/format.png';
import _imports_2 from '@/assets/images/sushi.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c9d61ec0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "top-box"
};
var _hoisted_2 = {
  class: "top-l"
};
var _hoisted_3 = {
  class: "info"
};
var _hoisted_4 = {
  class: "txt-box"
};
var _hoisted_5 = {
  class: "title-bar"
};
var _hoisted_6 = {
  class: "title"
};
var _hoisted_7 = {
  class: "list"
};
var _hoisted_8 = {
  class: "item"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "left-title"
  }, "主题名", -1);
});

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" ： ");

var _hoisted_11 = {
  class: "line-word"
};
var _hoisted_12 = {
  class: "item"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "left-title"
  }, "卷号", -1);
});

var _hoisted_14 = /*#__PURE__*/_createTextVNode(" ： ");

var _hoisted_15 = {
  class: "line-word"
};

var _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"item\" data-v-c9d61ec0><span class=\"left-title\" data-v-c9d61ec0>姓氏</span> ： <span class=\"line-word\" data-v-c9d61ec0>王</span></div><div class=\"item\" data-v-c9d61ec0><span class=\"left-title\" data-v-c9d61ec0>更新日期</span> ： <span class=\"line-word\" data-v-c9d61ec0>2022-03-16</span></div>", 2);

var _hoisted_18 = {
  class: "top-r"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top-bar"
  }, "谱书样式", -1);
});

var _hoisted_20 = {
  class: "list"
};
var _hoisted_21 = {
  class: "item"
};
var _hoisted_22 = {
  class: "item"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "img"
  }, null, -1);
});

var _hoisted_24 = /*#__PURE__*/_createTextVNode("编辑内容");

var _hoisted_25 = {
  class: "item"
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "img"
  }, null, -1);
});

var _hoisted_27 = /*#__PURE__*/_createTextVNode("版式设置");

var _hoisted_28 = {
  class: "item"
};

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "img"
  }, null, -1);
});

var _hoisted_30 = /*#__PURE__*/_createTextVNode("一键应用");

var _hoisted_31 = {
  class: "table"
};
var _hoisted_32 = {
  class: "page-header"
};

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "page-header-left"
  }, "体例明细（1/5）", -1);
});

var _hoisted_34 = /*#__PURE__*/_createTextVNode("生成下载");

var _hoisted_35 = {
  key: 1,
  class: "table-empty"
};
var _hoisted_36 = {
  class: "btn-v"
};

var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "编辑内容", -1);
});

var _hoisted_38 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "选择版式", -1);
});

var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "生成下载", -1);
});

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "tips"
  }, "您还没有生成家谱体例，赶块按照步骤生成吧~", -1);
});

import { ref, watch } from 'vue';
import Book from '@/components/book';
import { options } from './options';
import { useRouter } from 'vue-router';
import { submitPrint, getPrintList, removePrint } from '@/api/print';
import { Delete } from '@element-plus/icons-vue';
import i18n from '@/i18n';
import { ElMessage } from 'element-plus';
export default {
  props: {
    data: {
      // 接收父组件传值,并设置默认值
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRouter();
    var tableData = ref([]);

    var handleDetails = function handleDetails() {
      route.push({
        name: 'BookDetails',
        query: {
          id: data.value.id
        }
      });
    };

    var handleConfigs = function handleConfigs() {
      route.push({
        name: 'BookConfigs',
        query: {
          id: data.value.id
        }
      });
    };

    var data = ref({});
    watch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data.value = props.data;

              if (data.value.id > 0) {
                getData();
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), {
      deep: true,
      immediate: true
    });

    var getData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getPrintList(data.value.id);

              case 2:
                res = _context2.sent;
                res.forEach(function (item) {
                  item.options = options;
                });
                tableData.value = res;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getData() {
        return _ref2.apply(this, arguments);
      };
    }();

    var handleSubmitPrint = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log(data.value);
                _context3.next = 3;
                return submitPrint(data.value);

              case 3:
                res = _context3.sent;
                console.log(res);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function handleSubmitPrint() {
        return _ref3.apply(this, arguments);
      };
    }();

    var handlePreview = function handlePreview(row) {
      route.push({
        name: 'PrintImg',
        query: {
          row: encodeURIComponent(JSON.stringify(row))
        }
      });
    };

    var deletePrint = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return removePrint(row.id);

              case 2:
                getData();
                ElMessage({
                  message: i18n.global.t('message.removeSuccess'),
                  type: 'success'
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function deletePrint(_x) {
        return _ref4.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      var _component_svg_icon = _resolveComponent("svg-icon");

      var _component_refresh = _resolveComponent("refresh");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_shopping_cart_full = _resolveComponent("shopping-cart-full");

      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_el_table = _resolveComponent("el-table");

      var _component_arrow_right = _resolveComponent("arrow-right");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(Book), {
        class: "pic",
        scale: "transform:scale(1.54)",
        title: data.value.pedigreeName
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(data.value.pedigreeName), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createElementVNode("span", _hoisted_11, _toDisplayString(data.value.name), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _hoisted_14, _createElementVNode("span", _hoisted_15, _toDisplayString(data.value.bookNumber), 1)]), _hoisted_16])])])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_unref(Book), {
        scale: "transform: scale(1.08);",
        title: data.value.pedigreeName
      }, null, 8, ["title"])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createVNode(_component_el_button, {
        plain: "",
        onClick: handleDetails
      }, {
        default: _withCtx(function () {
          return [_hoisted_24];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createVNode(_component_el_button, {
        plain: "",
        onClick: handleConfigs
      }, {
        default: _withCtx(function () {
          return [_hoisted_27];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createVNode(_component_el_button, {
        plain: ""
      }, {
        default: _withCtx(function () {
          return [_hoisted_30];
        }),
        _: 1
      })])])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_hoisted_33, _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmitPrint
      }, {
        default: _withCtx(function () {
          return [_hoisted_34];
        }),
        _: 1
      })]), tableData.value.length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: tableData.value,
        stripe: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), function (item, index) {
            return _openBlock(), _createBlock(_component_el_table_column, {
              prop: item.prop,
              label: _ctx.$t("table.".concat(item.label)),
              key: index,
              width: item.width
            }, _createSlots({
              _: 2
            }, [item.prop === 'action' ? {
              name: "default",
              fn: _withCtx(function (_ref5) {
                var row = _ref5.row;
                return [_createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  icon: _unref(Delete),
                  onClick: function onClick($event) {
                    return deletePrint(row);
                  }
                }, null, 8, ["icon", "onClick"])];
              })
            } : item.prop === 'book' ? {
              name: "default",
              fn: _withCtx(function (_ref6) {
                var row = _ref6.row;
                return [_createElementVNode("div", {
                  class: "table-tili"
                }, [_createElementVNode("div", {
                  class: "pic"
                }, [_createElementVNode("img", {
                  src: _imports_2,
                  alt: ""
                }), _createElementVNode("div", {
                  class: "mask"
                }, [_createElementVNode("span", {
                  class: "btn"
                }, "预览")])]), _createElementVNode("div", {
                  class: "txt-box"
                }, [_createElementVNode("div", {
                  class: "title"
                }, _toDisplayString(row.name), 1), _createElementVNode("div", {
                  class: "row"
                }, [_createElementVNode("span", {
                  class: "txt"
                }, "成员数：17"), _createElementVNode("span", {
                  class: "txt"
                }, "页面数：10")]), _createElementVNode("div", {
                  class: "time"
                }, _toDisplayString(row.createTime), 1)])])];
              })
            } : item.prop === 'priview' ? {
              name: "default",
              fn: _withCtx(function (_ref7) {
                var row = _ref7.row;
                return [_createVNode(_component_el_button, {
                  type: "text",
                  onClick: function onClick($event) {
                    return handlePreview(row);
                  }
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_svg_icon, {
                      icon: "eye-open",
                      onClick: _ctx.changeType,
                      class: "icon",
                      style: {
                        "font-size": "14px"
                      }
                    }, null, 8, ["onClick"]), _createTextVNode(" 预览 ")];
                  }),
                  _: 2
                }, 1032, ["onClick"])];
              })
            } : item.prop === 'standard' ? {
              name: "default",
              fn: _withCtx(function (_ref8) {
                var row = _ref8.row;
                return [_createVNode(_component_el_button, {
                  type: "text",
                  onClick: function onClick($event) {
                    return handlePreview(row);
                  }
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_el_icon, {
                      class: "icon"
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_refresh)];
                      }),
                      _: 1
                    }), _createTextVNode(" 生成 ")];
                  }),
                  _: 2
                }, 1032, ["onClick"])];
              })
            } : item.prop === 'highquality' ? {
              name: "default",
              fn: _withCtx(function (_ref9) {
                var row = _ref9.row;
                return [_createVNode(_component_el_button, {
                  type: "text",
                  onClick: function onClick($event) {
                    return handlePreview(row);
                  }
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_el_icon, {
                      class: "icon"
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_refresh)];
                      }),
                      _: 1
                    }), _createTextVNode(" 生成 ")];
                  }),
                  _: 2
                }, 1032, ["onClick"])];
              })
            } : item.prop === 'print' ? {
              name: "default",
              fn: _withCtx(function (_ref10) {
                var row = _ref10.row;
                return [_createVNode(_component_el_button, {
                  type: "text",
                  onClick: function onClick($event) {
                    return handlePreview(row);
                  }
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_el_icon, {
                      class: "icon"
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_shopping_cart_full)];
                      }),
                      _: 1
                    }), _createTextVNode(" 印谱 ")];
                  }),
                  _: 2
                }, 1032, ["onClick"])];
              })
            } : item.prop === 'wxshow' ? {
              name: "default",
              fn: _withCtx(function (_ref11) {
                _objectDestructuringEmpty(_ref11);

                return [_createElementVNode("span", null, "需先生成正稿")];
              })
            } : undefined]), 1032, ["prop", "label", "width"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["data"])) : (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: handleDetails
      }, {
        default: _withCtx(function () {
          return [_hoisted_37];
        }),
        _: 1
      }), _createVNode(_component_el_icon, {
        class: "rightIcon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_arrow_right)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: handleConfigs
      }, {
        default: _withCtx(function () {
          return [_hoisted_38];
        }),
        _: 1
      }), _createVNode(_component_el_icon, {
        class: "rightIcon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_arrow_right)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small"
      }, {
        default: _withCtx(function () {
          return [_hoisted_39];
        }),
        _: 1
      })]), _hoisted_40]))])], 64);
    };
  }
};